module.exports = __webpack_public_path__ + "static/media/IMG_3044.fbf9e95a.JPG";